AoPS.Utils.initKeyChain(AoPS, "Contests", "Views");

AoPS.Contests.Views = (function (Views) {
	// Overall landing page when there are multiple contests
	Views.ContestLandingMain = AoPS.View.extend({
		template_id: "#contest-landing-main-tpl",
		className: "contest-landing-main",
		initialize: function (options) {
			this.vars = {};
			this.render();
		},
		render: function () {
			// counter functions for Handlebars
			// determines if an event should be considered an additional event (under "load more")
			var upcoming_counter = 0;
			var past_counter = 0;
			Handlebars.registerHelper("upcomingCounter", function (max) {
				return ++upcoming_counter > max;
			});
			Handlebars.registerHelper("pastCounter", function (max) {
				return ++past_counter > max;
			});
			if (this.model.get("events") !== undefined) {
				Handlebars.registerPartial("events", this.model.get("events"));
			}
			if (this.model.get("ad") !== undefined) {
				Handlebars.registerPartial("ad", this.model.get("ad"));
			}

			this.getTemplateVariables();
			if (!this.model.get("isProduction")) {
				console.log("Displays on Test Servers Only:", this.vars);
			}

			this.$el.html(this.getTemplate(this.template_id, this.vars));
			this.$cms = this.$(".cms-inner");

			this.renderCms();
			this.renderHelper();
		},
		renderHelper: function () {
			AoPS.Contests.Utils.setupLandingPage();
			AoPS.Contests.Utils.setFAQsEventListeners();
			AoPS.Contests.Utils.scrollTo();
		},
		renderCms: function () {
			this.$cms
				.empty()
				.html(this.model.getCmsTemplate("#landing-main-tpl", this.vars));
		},
		getTemplateVariables: function () {
			// get contest events from /data-aops/cms/contests/objects/events.json
			var contest_events = this.model.get("contest_events");
			var events = AoPS.Contests.Utils.processEvents(contest_events);

			this.vars = _.extend(this.vars, events);

			this.vars.is_logged_in = AoPS.session.logged_in;

			return this.vars;
		},
		constructCrumbs: function () {
			return [];
		},
	});

	// Landing for one contest or when contest selected.
	Views.ContestLandingContest = AoPS.View.extend({
		template_id: "#contest-landing-contest-tpl",
		className: "contest-landing-main",
		initialize: function (options) {
			this.vars = {};

			this.flavor_method_name = this.model.get("flavor")
				? this.model.get("flavor").get("flavor_method_name")
				: null;

			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceBeforeRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceBeforeRender"]();
			}

			this.render();

			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceAfterRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceAfterRender"]();
			}
		},
		render: function () {
			// counter functions for Handlebars
			// determines if an event should be considered an additional event (under "load more")
			var upcoming_counter = 0;
			var past_counter = 0;
			Handlebars.registerHelper("upcomingCounter", function (max) {
				return ++upcoming_counter > max;
			});
			Handlebars.registerHelper("pastCounter", function (max) {
				return ++past_counter > max;
			});
			if (this.model.get("master").get("events") !== undefined) {
				Handlebars.registerPartial(
					"events",
					this.model.get("master").get("events")
				);
			}
			if (this.model.get("master").get("ad") !== undefined) {
				Handlebars.registerPartial("ad", this.model.get("master").get("ad"));
			}
			if (this.model.get("master").get("faqs") !== undefined) {
				Handlebars.registerPartial(
					"faqs",
					this.model.get("master").get("faqs")
				);
			}

			this.getTemplateVariables();
			if (!this.model.get("master").get("isProduction")) {
				console.log("Displays on Test Servers Only:", this.vars);
			}

			this.$el.html(this.getTemplate(this.template_id, this.vars));

			this.$cms = this.$(".cms-inner");
			this.renderCms();
			this.renderHelper();

			var $test_dropzone = this.$("#test-dropzone");
			if ($test_dropzone && $test_dropzone.data("problem-flavor")) {
				this.model.getProblemType(
					$test_dropzone.data("problem-flavor"),
					_.bind(this.renderTestDropzone, this)
				);
			}
		},
		renderHelper: function () {
			AoPS.Contests.Utils.setupLandingPage();
			AoPS.Contests.Utils.setFAQsEventListeners();
			AoPS.Contests.Utils.scrollTo();
		},
		renderTestDropzone: function (format_data) {
			this.$("#test-dropzone").html(
				this.getTemplate("#contests-tpl-dropzone", {
					title:
						"Test Contest Submission PDF Upload (This is NOT for real contest submissions.)",
					id: "test",
					no_file_msg: format_data.no_file_msg,
					with_file_msg: format_data.with_file_msg,
				})
			);
			var registration_id = this.vars.registration.contest_registration_id;
			var contest_hash = this.model.get("contest_hash");
			this.$("#droptest.dropzone").dropzone({
				url: "/m/contests/dropzone_example_upload.php",
				accept: function (file, done) {
					if (this.currentFile && format_data.max_files === 1) {
						this.removeFile(this.currentFile);
						this.currentFile = false;
					}
					var ext = file.name.split(".").pop().toLowerCase();
					if (_.indexOf(format_data.allowed_files, ext) < 0) {
						done(
							"Error! Files of this type are not accepted. Allowed types are: " +
								format_data.allowed_files.join(", ") +
								"."
						);
					}
					done();
					$(window).trigger("resize");
				},
				sending: function (file, xhr, formData) {
					formData.append("contest_hash", contest_hash);
					formData.append("registration_id", registration_id);
					$(window).trigger("resize");
				},
				removedfile: function (file) {
					if (
						_.isObject(file.previewElement) &&
						_.isObject(file.previewElement.parentNode)
					) {
						file.previewElement.parentNode.removeChild(file.previewElement);
					}
					$(window).trigger("resize");
					return this._updateMaxFilesReachedClass();
				},
				maxFilesize: format_data.max_filesize,
				maxFiles: format_data.max_files === 1 ? 2 : format_data.max_files,
				success: function (file, response) {
					var data = JSON.parse(response);
					if (data.error_code) {
						AoPS.Ui.Modal.showAlert(data.error_msg);
						this.removeFile(file);
						this.currentFile = false;
					} else {
						this.currentFile = file;
						var submission = data.response;
						if (submission) {
							self
								.$("#problem-test-submission")
								.html(
									'<i class="fas fa-check-circle" style="color: darkgreen;"></i>Your Submission: <a href="' +
										data.response.file_path +
										'" target="_blank">' +
										data.response.pretty_file_name +
										"</a>"
								);
						}
						$(file.previewElement).addClass("dz-success");
					}
					$(window).trigger("resize");
				},
				error: function (file, error) {
					if (error.substr(0, 15) === "File is too big") {
						AoPS.Ui.Modal.showAlert(
							"Your file is too large. You may only upload files up to 2 MB."
						);
					} else {
						AoPS.Ui.Modal.showAlert(error);
					}
					this.removeFile(file);
					$(window).trigger("resize");
				},
			});
		},
		renderCms: function () {
			if (
				this.flavor_method_name &&
				_.isFunction(this["process" + this.flavor_method_name + "BeforeRender"])
			) {
				this["process" + this.flavor_method_name + "BeforeRender"]();
			}

			this.$cms
				.empty()
				.html(this.model.getCmsTemplate("#landing-contest-tpl", this.vars));

			if (
				this.flavor_method_name &&
				_.isFunction(this["process" + this.flavor_method_name + "AfterRender"])
			) {
				this["process" + this.flavor_method_name + "AfterRender"]();
			}
		},
		getTemplateVariables: function () {
			var contest_hash = this.model.get("contest_hash");
			// get contest events from /data-aops/cms/contests/objects/events.json
			var contest_events = this.model.get("master").get("contest_events");
			if (contest_events) {
				var events = AoPS.Contests.Utils.processEvents(
					contest_events,
					contest_hash
				);
				this.vars = _.extend(this.vars, events);
			}

			this.vars.supervisor = AoPS.bd.supervisor;

			// get contest FAQs from /data-aops/cms/contests/objects/<contest_string>.json
			var faqs = this.model.get("master").get("contest_faqs");
			if (faqs) {
				faqs = AoPS.Contests.Utils.processFAQs(faqs);
				this.vars.faqs = Object.keys(faqs).length ? faqs : false;
			}

			return _.extend(this.vars, this.model.export());
		},
		constructCrumbs: function () {
			return [
				{
					text:
						this.model.get("contest_crumb_name") ||
						this.model.get("contest_name"),
				},
			];
		},
		processMathcountsWeekOnceAfterRender: function () {
			// Listeners are usually placed here.
			// Actual template is in data repo, under /contests/flavor_mathcounts.handlebars
			var self = this;

			setTimeout(function () {
				self.highlightDayHeader();

				// Only set intervals to update the timer if there is time.
				var now = Date.now();

				var start_unix =
					self.vars["official_individual_contest_start_unix_time"];
				if (start_unix < now) {
					// The template handles this case, so do nothing
				} else {
					self.updateCountdownTimer(
						$(".contest-individual-timer .countdown-container"),
						start_unix
					);
				}

				start_unix = self.vars["official_team_contest_start_unix_time"];
				if (start_unix < now) {
					// The template handles this case, so do nothing
				} else {
					self.updateCountdownTimer(
						$(".contest-team-timer .countdown-container"),
						start_unix
					);
				}
			}, 0);
		},
		processMathcountsWeekAfterRender: function () {
			// Add more functionality here after each time it rerenders
		},
		processAcademyProblemSolversOnceAfterRender: function () {
			// Listeners are usually placed here.
			// Actual template is in data repo, under /contests/flavor_mathcounts.handlebars
			var self = this;

			setTimeout(function () {
				self.highlightDayHeader();

				// Only set intervals to update the timer if there is time.
				var now = Date.now();

				var start_unix =
					self.vars["official_individual_contest_start_unix_time"];
				if (start_unix < now) {
					// The template handles this case, so do nothing
				} else {
					self.updateCountdownTimer(
						$(".contest-individual-timer .countdown-container"),
						start_unix
					);
				}

				start_unix = self.vars["official_team_contest_start_unix_time"];
				if (start_unix < now) {
					// The template handles this case, so do nothing
				} else {
					self.updateCountdownTimer(
						$(".contest-team-timer .countdown-container"),
						start_unix
					);
				}
			}, 0);
		},
		processAimeOnceAfterRender: function () {
			var self = this;
			setTimeout(function () {
				// Only set intervals to update the timer if there is time.
				var now = Date.now();

				var start_unix =
					self.vars["official_individual_contest_start_unix_time"];
				if (start_unix < now) {
					// The template handles this case, so do nothing
				} else {
					self.updateCountdownTimer(
						$(".contest-individual-timer .countdown-container"),
						start_unix
					);
				}
			}, 0);
		},
		processMaaOlympiadOnceAfterRender: function () {
			var self = this;
			setTimeout(function () {
				// Only set intervals to update the timer if there is time.
				var now = Date.now();

				var start_unix =
					self.vars["official_individual_contest_start_unix_time"];
				if (start_unix < now) {
					// The template handles this case, so do nothing
				} else {
					self.updateCountdownTimer(
						$(".contest-individual-timer .countdown-container"),
						start_unix
					);
				}
			}, 0);
		},
		processUSABOSemifinalBeforeRender: function () {
			AoPS.Contests.Utils.initStaggerVars.call(this, "USABOSemifinal");
		},
		processUSABOSemifinalAfterRender: function () {
			AoPS.Contests.Utils.initCountdown.call(this);
		},
		processF_maBeforeRender: function () {
			AoPS.Contests.Utils.initStaggerVars.call(this, "F_ma");
		},
		processF_maAfterRender: function () {
			AoPS.Contests.Utils.initCountdown.call(this);
		},
		highlightDayHeader: function () {
			var today = new Date();
			var month = `${today.getMonth() + 1}`;
			var day = `${today.getDate()}`;
			var year = `${today.getFullYear()}`.slice(2);

			var $scheduleHeaders = $(".contest-schedule-day-header");

			_.each($scheduleHeaders, function (header) {
				var headerDate = $(header).text().split(" ")[1].trim();
				var todayDateString = `${month}/${day}/${year}`;
				if (headerDate === todayDateString) {
					$(header).addClass("highlight-today");
				}
			});
		},
		updateCountdownTimer: function ($el, startTime) {
			setInterval(
				_.bind(function () {
					var remainingSeconds = startTime - Date.now();

					if (remainingSeconds < 0) {
						var is_team = $el.parents(".contest-timer").attr("is_team");
						var end_unix_time = is_team
							? this.vars.official_team_contest_end_unix_time
							: this.vars.official_individual_contest_end_unix_time;

						if (end_unix_time < Date.now()) {
							$el.parent().html("This contest has officially ended.");
						} else {
							var href = is_team
								? this.vars.contest_team_url
								: this.vars.contest_individual_url;
							$el
								.parents(".countdown-words")
								.html(
									$("<a />")
										.attr("href", href)
										.text("START CONTEST")
										.addClass("btn btn-primary")
								);
						}
					} else {
						var countDownTime = this.parseUnixTimeToCountdown(remainingSeconds);

						_.each($el.find("div"), function (unit, unitIndex) {
							_.each($(unit).find("span"), function (digit, digitIndex) {
								$(digit).text(countDownTime[unitIndex][digitIndex]);
							});
						});
					}
				}, this),
				1000
			);
		},
		parseUnixTimeToCountdown: function (countdownTime) {
			if (countdownTime < 0) {
				return Array(4).fill(["0", "0"]);
			}

			var days = `${Math.floor(countdownTime / (1000 * 60 * 60 * 24))}`;
			countdownTime %= 1000 * 60 * 60 * 24;
			var hours = `${Math.floor(countdownTime / (1000 * 60 * 60))}`;
			countdownTime %= 1000 * 60 * 60;
			var minutes = `${Math.floor(countdownTime / (1000 * 60))}`;
			countdownTime %= 1000 * 60;
			var seconds = `${Math.floor(countdownTime / 1000)}`;

			var dayDigits = days.split("");
			var hourDigits = hours.split("");
			var minuteDigits = minutes.split("");
			var secondDigits = seconds.split("");

			if (dayDigits.length > 2) {
				dayDigits = ["9", "9"];
			} else if (dayDigits.length === 1) {
				dayDigits = ["0", dayDigits[0]];
			} else if (dayDigits.length <= 0) {
				dayDigits = ["0", "0"];
			}

			if (hourDigits.length > 2) {
				hourDigits = ["2", "4"];
			} else if (hourDigits.length === 1) {
				hourDigits = ["0", hourDigits[0]];
			} else if (hourDigits.length <= 0) {
				hourDigits = ["0", "0"];
			}

			if (minuteDigits.length > 2) {
				minuteDigits = ["6", "0"];
			} else if (minuteDigits.length === 1) {
				minuteDigits = ["0", minuteDigits[0]];
			} else if (minuteDigits.length <= 0) {
				minuteDigits = ["0", "0"];
			}

			return [dayDigits, hourDigits, minuteDigits, secondDigits];
		},
		parseDateString: function (year, monthDay, time) {
			var [month, day] = monthDay.split(" ");
			return new Date(`${day} ${month} ${year} ${time} EST`).getTime();
		},
	});

	Views.ContestLandingLoading = AoPS.View.extend({
		template_id: "#contest-landing-loading-tpl",
		className: "contest-landing-main contest-landing-padded",
		initialize: function (options) {
			this.render();
		},
		render: function () {
			this.$el.html(this.getTemplate(this.template_id, {}));
			this.$(".loading-inner").append(AoPS.Page.$loader.clone());
		},
		constructCrumbs: function () {
			return [];
		},
	});

	Views.ContestDetails = AoPS.View.extend({
		template_id: "#contest-details-tpl",
		className: "contest-details-main",
		initialize: function () {
			this.vars = {};
			this.render();
		},
		render: function () {
			this.$el.html(this.getTemplate(this.template_id, this.vars));
			this.$cms = this.$(".details-content");

			this.renderCms();
		},
		renderCms: function () {
			if (
				this.flavor_method_name &&
				_.isFunction(this["process" + this.flavor_method_name + "BeforeRender"])
			) {
				this["process" + this.flavor_method_name + "BeforeRender"]();
			}

			this.getTemplateVariables();

			this.$cms
				.empty()
				.html(this.model.getCmsTemplate("#contest-details-tpl", this.vars));

			if (
				this.flavor_method_name &&
				_.isFunction(this["process" + this.flavor_method_name + "AfterRender"])
			) {
				this["process" + this.flavor_method_name + "AfterRender"]();
			}
		},
		getTemplateVariables: function () {
			return _.extend(this.vars, this.model.export());
		},
		constructCrumbs: function () {
			return [];
		},
	});

	Views.ContestLandingLoadError = AoPS.View.extend({
		template_id: "#contest-landing-load-error-tpl",
		className: "contest-landing-main contest-landing-padded",
		initialize: function (options) {
			this.render();
		},
		render: function () {
			this.$el.html(this.getTemplate(this.template_id, {}));
		},
		constructCrumbs: function () {
			return [
				{
					text: "Register",
				},
			];
		},
	});

	return Views;
})(AoPS.Contests.Views);
